import { render, staticRenderFns } from "./ProjectComponentPanel.vue?vue&type=template&id=6e372077&"
import script from "./ProjectComponentPanel.vue?vue&type=script&lang=js&"
export * from "./ProjectComponentPanel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports